export default (url: string | URL, options?: RequestInit, timeout: number = 10000): Promise<Response> => {
    return Promise.race([
        fetch(url, options),
        new Promise<Response>((__, reject) =>
            setTimeout(() => { reject(new Error("timeout")); }, timeout),
        ),
    ]);
};
